<template>
	<div class="form-torvalla-bil-open-modal form" :class="{ 'nitea-modal-inner': isModalMode }">
		<div class="form-torvalla-bil-open-repost-card form-inner">

			<!-- Formulär-header endast i modal-läge -->
			<div v-if="isModalMode" class="form-header-container flex-row flex-align-center flex-justify-between">
				<button type="button" class="nitea-modal-close nitea-button is-primary is-outlined is-width-auto is-size-small has-icon-only" @click="closeModal()" aria-label="Stäng">
					<span class="icon-close icon--small"></span>
				</button>
				<div v-if="formTitle || formDescription" class="form-header">
					<template v-if="formTitle || (formDescription && mailSentStatus == null)">
						<h2 v-if="formTitle" class="form-title has-medium-font-size">{{ formTitle }}</h2>
						<p v-if="formDescription" class="form-description">{{ formDescription }}</p>
					</template>
				</div>
			</div>

			<div v-if="mailSentStatus == 'sent'">
				<h2 class="form-section-title has-large-font-size font-weight-medium">Tack!</h2>
				<p>Ditt meddelande har skickats!</p>
			</div>
			<div v-else-if="mailSentStatus == 'error'">
				<h2 class="form-section-title has-large-font-size font-weight-medium">Förlåt!</h2>
				<p>Men ditt meddelande kunde inte skickas! Vänligen ring oss</p>
			</div>

			<form v-if="mailSentStatus === null || mailSentStatus === 'sending'" class="form-container">

					<!-- Kontaktuppgifter -->
					<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">1. Kontaktuppgifter *</h2>
					<div class="form-grid">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.firstName.$dirty && $v.fields.firstName.$error,
								'has-success': $v.fields.firstName.$dirty && !$v.fields.firstName.$error && fields.firstName && fields.firstName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-firstname'" placeholder=" " v-model="fields.firstName" @blur="$v.fields.firstName.$touch()" required="required" />
							<label :for="blockId + '-firstname'" class="floating-label">Förnamn</label>
							<div v-if="$v.fields.firstName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt förnamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.lastName.$dirty && $v.fields.lastName.$error,
								'has-success': $v.fields.lastName.$dirty && !$v.fields.lastName.$error && fields.lastName && fields.lastName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-lastname'" placeholder=" " v-model="fields.lastName" @blur="$v.fields.lastName.$touch()" required="required" />
							<label :for="blockId + '-lastname'" class="floating-label">Efternamn</label>
							<div v-if="$v.fields.lastName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt efternamn</div>
							</div>
						</div>

					<div
						class="form-group floating-label"
						:class="{
								'has-error': $v.fields.email.$dirty && $v.fields.email.$error,
								'has-success': $v.fields.email.$dirty && !$v.fields.email.$error && fields.email && fields.email.length > 0,
							}"
						>
							<input type="email" :id="blockId + '-email'" placeholder=" " v-model="fields.email" @blur="$v.fields.email.$touch()" required="required" />
							<label :for="blockId + '-email'" class="floating-label">E-post</label>
							<div v-if="$v.fields.email.$error" class="validation-messages">
								<div v-if="!$v.fields.email.required" class="validation-message error">Vänligen ange din e-postadress</div>
								<div v-else-if="!$v.fields.email.email" class="validation-message error">Vänligen ange en giltig e-postadress</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.phone.$dirty && $v.fields.phone.$error,
								'has-success': $v.fields.phone.$dirty && !$v.fields.phone.$error && fields.phone && fields.phone.length > 0,
							}"
						>
							<input type="tel" :id="blockId + '-phone'" placeholder=" " v-model="fields.phone" @blur="$v.fields.phone.$touch()" required="required" />
							<label :for="blockId + '-phone'" class="floating-label">Telefonnummer</label>
							<div v-if="$v.fields.phone.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt telefonnummer</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.golfId.$dirty && $v.fields.golfId.$error,
								'has-success': $v.fields.golfId.$dirty && !$v.fields.golfId.$error && fields.golfId && fields.golfId.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-golfid'" placeholder="123456-000" v-model="fields.golfId" @blur="$v.fields.golfId.$touch()" required="required" />
							<label :for="blockId + '-golfid'" class="floating-label">Golf ID</label>
							<div v-if="$v.fields.golfId.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt Golf ID</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Vill du ta med dig en partner? -->
				<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">2. Vill du ta med dig en partner? *</h2>
					<div class="form-section">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.hasPartner.$dirty && $v.fields.hasPartner.$error,
								'has-success': $v.fields.hasPartner.$dirty && !$v.fields.hasPartner.$error && fields.hasPartner && fields.hasPartner.length > 0,
							}"
						>
							<select :id="blockId + '-has-partner'" v-model="fields.hasPartner" @blur="$v.fields.hasPartner.$touch()" required="required">
								<option value="">Välj</option>
								<option value="Ja">Ja</option>
								<option value="Nej">Nej</option>
							</select>
							<label :for="blockId + '-has-partner'" class="floating-label">Vill du ta med dig en partner?</label>
							<div v-if="$v.fields.hasPartner.$error" class="validation-messages">
								<div class="validation-message error">Vänligen välj om du vill ta med en partner</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Partnerfält (villkorlig visning) -->
				<div v-if="fields.hasPartner === 'Ja'" class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">3. Kontaktuppgifter för partner *</h2>
					<div class="form-grid">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.partnerFirstName.$dirty && $v.fields.partnerFirstName.$error,
								'has-success': $v.fields.partnerFirstName.$dirty && !$v.fields.partnerFirstName.$error && fields.partnerFirstName && fields.partnerFirstName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-partner-firstname'" placeholder=" " v-model="fields.partnerFirstName" @blur="$v.fields.partnerFirstName.$touch()" required="required" />
							<label :for="blockId + '-partner-firstname'" class="floating-label">Partner: Förnamn</label>
							<div v-if="$v.fields.partnerFirstName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange partners förnamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.partnerLastName.$dirty && $v.fields.partnerLastName.$error,
								'has-success': $v.fields.partnerLastName.$dirty && !$v.fields.partnerLastName.$error && fields.partnerLastName && fields.partnerLastName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-partner-lastname'" placeholder=" " v-model="fields.partnerLastName" @blur="$v.fields.partnerLastName.$touch()" required="required" />
							<label :for="blockId + '-partner-lastname'" class="floating-label">Partner: Efternamn</label>
							<div v-if="$v.fields.partnerLastName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange partners efternamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.partnerEmail.$dirty && $v.fields.partnerEmail.$error,
								'has-success': $v.fields.partnerEmail.$dirty && !$v.fields.partnerEmail.$error && fields.partnerEmail && fields.partnerEmail.length > 0,
							}"
						>
							<input type="email" :id="blockId + '-partner-email'" placeholder=" " v-model="fields.partnerEmail" @blur="$v.fields.partnerEmail.$touch()" required="required" />
							<label :for="blockId + '-partner-email'" class="floating-label">Partner: E-post</label>
							<div v-if="$v.fields.partnerEmail.$error" class="validation-messages">
								<div v-if="!$v.fields.partnerEmail.required" class="validation-message error">Vänligen ange partners e-postadress</div>
								<div v-else-if="!$v.fields.partnerEmail.email" class="validation-message error">Vänligen ange en giltig e-postadress</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.partnerGolfId.$dirty && $v.fields.partnerGolfId.$error,
								'has-success': $v.fields.partnerGolfId.$dirty && !$v.fields.partnerGolfId.$error && fields.partnerGolfId && fields.partnerGolfId.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-partner-golfid'" placeholder=" " v-model="fields.partnerGolfId" @blur="$v.fields.partnerGolfId.$touch()" required="required" />
							<label :for="blockId + '-partner-golfid'" class="floating-label">Partner: Golf ID</label>
							<div v-if="$v.fields.partnerGolfId.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange partners Golf ID</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Integritetspolicy -->
				<div class="form-footer">
					<div class="radio-group" :class="{ 'has-error': $v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$invalid && $v.fields.privacyPolicy.$error }">
						<input type="checkbox" :id="blockId + '-checkbox'" v-model="fields.privacyPolicy" @change="$v.fields.privacyPolicy.$touch()" />
						<label :for="blockId + '-checkbox'" class="has-caption-font-size">Jag accepterar <a href="/integritetspolicy/" target="_blank" class="has-caption-font-size">integritetspolicyn</a></label>
						<div v-if="$v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$invalid && $v.fields.privacyPolicy.$error" class="validation-messages">
							<div class="validation-message error">Du måste acceptera integritetspolicyn</div>
						</div>
					</div>
					<button
						type="button"
						:class="{
							'is-loading': mailSentStatus === 'sending',
							'is-disabled': isFormDisabled,
							'is-filled': !isFormDisabled && !mailSentStatus,
						}"
						class="nitea-button is-primary is-width-auto is-size-default"
						@click="submitForm()"
						:disabled="isFormDisabled"
					>
						Skicka
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { required, requiredIf, email } from "vuelidate/lib/validators";

	// Custom validator for checkbox
	const mustBeTrue = (value) => value === true;

	export default {
		name: "form-torvalla-bil-open",
		props: {
			postId: {
				type: Number,
				default: null,
			},
			isModalOpen: {
				type: Boolean,
				default: false,
			},
			formTitle: {
				type: String,
				default: "",
			},
			formDescription: {
				type: String,
				default: "",
			},
			blockId: {
				type: String,
				default: "form-torvalla-bil-open",
			},
			emailRecipients: {
				type: String,
				default: "",
			},
			emailSubject: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				mailSentStatus: null,
			fields: {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				golfId: "",
				hasPartner: "",
				partnerFirstName: "",
				partnerLastName: "",
				partnerEmail: "",
				partnerGolfId: "",
				privacyPolicy: false,
			},
				// Lokala kopior av props för att undvika mutation
				localEmailRecipients: this.emailRecipients,
				localEmailSubject: this.emailSubject,
			};
		},
		computed: {
			isModalMode() {
				// Om isModalOpen är true, är det modal-läge, Annars är det embedded-läge
				return this.isModalOpen;
			},
			isFormDisabled() {
				// Formuläret är disabled om:
				// 1. Meddelande skickas för närvarande
				// 2. Formuläret är ogiltigt (saknade obligatoriska fält)
				
				return this.mailSentStatus === "sending" || this.$v.fields.$invalid;
			},
		},
		validations: {
			fields: {
				firstName: { required },
				lastName: { required },
				email: { required, email },
				phone: { required },
				golfId: { required },
				hasPartner: { required },
				partnerFirstName: { required: requiredIf(function() { return this.fields.hasPartner === 'Ja'; }) },
				partnerLastName: { required: requiredIf(function() { return this.fields.hasPartner === 'Ja'; }) },
				partnerEmail: { 
					required: requiredIf(function() { return this.fields.hasPartner === 'Ja'; }),
					email
				},
				partnerGolfId: { required: requiredIf(function() { return this.fields.hasPartner === 'Ja'; }) },
				privacyPolicy: { mustBeTrue }
			},
		},
		watch: {
			// Uppdatera lokala kopior när props ändras
			emailRecipients(newVal) {
				this.localEmailRecipients = newVal;
			},
			emailSubject(newVal) {
				this.localEmailSubject = newVal;
			},
		},
		mounted() {
			// Läs postId från data-attribut om det inte skickats som prop
			if (!this.postId && this.$el && this.$el.hasAttribute("data-post-id")) {
				const postId = this.$el.getAttribute("data-post-id");
				this.postId = postId ? parseInt(postId) : null;
			}

			// Läs formulär-information från data-attribut om det inte skickats som props
			if (!this.formTitle && this.$el && this.$el.hasAttribute("data-form-title")) {
				this.formTitle = this.$el.getAttribute("data-form-title") || "";
			}
			if (!this.formDescription && this.$el && this.$el.hasAttribute("data-form-description")) {
				this.formDescription = this.$el.getAttribute("data-form-description") || "";
			}

			// Läs blockId från data-attribut om det inte skickats som prop
			if (!this.blockId && this.$el && this.$el.hasAttribute("data-block-id")) {
				this.blockId = this.$el.getAttribute("data-block-id") || "form-torvalla-bil-open";
			}
		},
		methods: {

			closeModal() {
				// Skicka event för att stänga modalen
				window.dispatchEvent(
					new CustomEvent("closeFormModal", {
						detail: { formType: "torvalla-bil-open" },
					}),
				);
			},
			submitForm() {
				this.$v.$touch();
				if (this.$v.$invalid) {
					return;
				}

				this.mailSentStatus = "sending";

				const formData = new FormData();
				formData.append("action", "nitea_utils_form_post_torvalla_bil_open");
				formData.append("post_id", this.postId);
				formData.append("first_name", this.fields.firstName);
				formData.append("last_name", this.fields.lastName);
				formData.append("email", this.fields.email);
				formData.append("phone", this.fields.phone);
				formData.append("golf_id", this.fields.golfId);
				formData.append("has_partner", this.fields.hasPartner);
				
				if (this.fields.hasPartner === 'Ja') {
					formData.append("partner_first_name", this.fields.partnerFirstName);
					formData.append("partner_last_name", this.fields.partnerLastName);
					formData.append("partner_email", this.fields.partnerEmail);
					formData.append("partner_golf_id", this.fields.partnerGolfId);
				}

				// Skicka med email-konfiguration från blocket
				if (this.localEmailRecipients) {
					formData.append("email_recipients", this.localEmailRecipients);
				}
				if (this.localEmailSubject) {
					formData.append("email_subject", this.localEmailSubject);
				}

				fetch(window.nitea_utils_forms_torvalla_bil_open.admin_url + "?action=nitea_utils_form_post_torvalla_bil_open", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.success) {
							this.mailSentStatus = "sent";
							this.resetForm();
						} else {
							this.mailSentStatus = "error";
						}
					})
					.catch((error) => {
						console.error("Error:", error);
						this.mailSentStatus = "error";
					});
			},
		resetForm() {
			this.fields = {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				golfId: "",
				hasPartner: "",
				partnerFirstName: "",
				partnerLastName: "",
				partnerEmail: "",
				partnerGolfId: "",
				privacyPolicy: false,
			};
			this.$v.$reset();
		},
		},
	};
</script>
